/**
 * Decide which design the single-product editor should open. Unsaved
 * changes (product toggles inside the auto-save debounce) must reach the
 * database first: loadDesign rebuilds the selection from the DB.
 */
export async function resolveEditPlacementDesignId(input: {
  designId: string | null;
  hasUnsavedChanges: boolean;
  saveDesign: () => Promise<{ id: string } | null>;
}): Promise<string | null> {
  const { designId, hasUnsavedChanges, saveDesign } = input;
  if (designId && !hasUnsavedChanges) return designId;
  const saved = await saveDesign();
  return saved?.id ?? null;
}
